import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'pfconfirmation';
export const route = 'pfconfirmation/[searchId]/[fareItineraryKey]/[segmentKeys]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "pfconfirmation" */
/* webpackPrefetch: true */
'../components/ConfirmationPage')));